var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoon = function SvgMoon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8968 15.7736C17.2888 15.9215 16.6536 16 16 16C11.5817 16 8 12.4183 8 8C8 7.34641 8.07848 6.71118 8.2264 6.10322C6.2859 7.34761 5 9.52363 5 12C5 15.866 8.13401 19 12 19C14.4764 19 16.6524 17.7141 17.8968 15.7736ZM18.8867 13.2612C18.0302 13.7321 17.0464 14 16 14C12.6863 14 10 11.3137 10 8C10 6.9536 10.2679 5.96976 10.7388 5.11332C11.0676 4.51535 11.4953 3.97948 12 3.52779C12.0431 3.48921 12.0868 3.45126 12.131 3.41393C12.2935 3.2767 12.2127 3 12 3V3C11.1273 3 10.2836 3.12422 9.48562 3.35593C5.73871 4.44396 3 7.90215 3 12C3 16.9706 7.02944 21 12 21C16.0979 21 19.556 18.2613 20.6441 14.5144C20.8758 13.7164 21 12.8727 21 12V12C21 11.7873 20.7233 11.7065 20.5861 11.869C20.5487 11.9132 20.5108 11.9569 20.4722 12C20.0205 12.5047 19.4847 12.9324 18.8867 13.2612Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moon.498431e10bc1f0d97405a70d20d4cb3b.svg";